<template>
  <div id="app">
      <div id="myApplication">
        <h1>{{ title }}</h1>

        <form class="add-row" @submit.prevent="addTask">
          <input id="inputAdd" v-model="currentTask" placeholder="Ajouter un article">
          <select v-model="newTaskCategory" class="form-control select-category">
            <option v-for="cat in categories" :key="cat" :value="cat">{{ cat }}</option>
          </select>
          <button type="submit" class="btn btn-success">+</button>
        </form>

        <hr style="width:10%">

        <div class="categories">
          <div class="category" v-for="cat in categories" :key="cat"
               @dragover.prevent
               @drop="dropOnCategory($event, cat)">
            <h3>{{ cat }}</h3>
            <div v-if="tasksByCategory(cat).length === 0" class="empty">Aucun article</div>
            <div class="task" v-for="(task, index) in tasksByCategory(cat)" :key="task._id"
                 draggable="true"
                 @dragstart="dragStart($event, index, cat)"
                 @dragover.prevent
                 @drop="dropOnTask($event, index, cat)">
              <span @click="toggleTask(globalIndex(task))" :class="{ strike: !task.show }">
                {{ task.title }}
              </span>
              <button class="btn btn-danger btn-sm delete-btn" v-on:click="delTask(globalIndex(task))">✕</button>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>

export default {
  data(){
    return{
      title: "Liste de course",
      currentTask: "",
      newTaskCategory: 'Autres',
      categories: ['Surgelé', 'Boulangerie', 'Fruits/Légumes', 'Boucherie', 'Laitage', 'Rayon frais', 'Autres'],
      tasks: [
      ],
      _nextId: 1
    }
  },
  mounted() {
    if (localStorage.tasks) {
      try{
        const saved = JSON.parse(localStorage.tasks);
        if (Array.isArray(saved)) this.tasks = saved;
      }catch(e){}
    }
  },
  methods: {
    addTask : function (event){
      if (this.currentTask!=""){
        this.tasks.push({ _id: this._nextId++, title:this.currentTask, show:true, category: this.newTaskCategory });
        this.currentTask="";
        this.saveToDo();
      }
    },
    delTask : function (index){
      this.tasks.splice(index, 1)
      this.saveToDo();
    },
    toggleTask : function (index){
      this.tasks[index].show = !this.tasks[index].show;
      this.saveToDo();
    },
    saveToDo : function(){
      const data = JSON.stringify(this.tasks);
      localStorage.tasks=data;
    },
    // Drag & drop helpers
    dragStart: function(event, indexInCategory, category){
      // compute global index of item
      const idx = this.tasksByCategory(category, true)[indexInCategory];
      event.dataTransfer.setData('text/plain', idx);
    },
    dropOnTask: function(event, indexInCategory, category){
      event.preventDefault();
      const sourceGlobal = Number(event.dataTransfer.getData('text/plain'));
      if (isNaN(sourceGlobal)) return;
      const targetGlobal = this.tasksByCategory(category, true)[indexInCategory];
      if (sourceGlobal === targetGlobal) return;
      const moved = this.tasks.splice(sourceGlobal,1)[0];
      // adjust target index after removal
      let insertAt = this.tasks.indexOf(this.tasks.find(t => t._id === this.tasks[targetGlobal]?._id));
      if (insertAt === -1) insertAt = this.tasks.length;
      // if source < insertAt, removing source shifted indices left
      if (sourceGlobal < insertAt) insertAt--;
      this.tasks.splice(insertAt, 0, moved);
      this.saveToDo();
    },
    dropOnCategory: function(event, category){
      event.preventDefault();
      const sourceGlobal = Number(event.dataTransfer.getData('text/plain'));
      if (isNaN(sourceGlobal)) return;
      const moved = this.tasks.splice(sourceGlobal,1)[0];
      moved.category = category;
      this.tasks.push(moved);
      this.saveToDo();
    },
    // helpers to present tasks grouped while preserving global order
    tasksByCategory: function(cat, returnGlobalIndex){
      const list = [];
      for (let i=0;i<this.tasks.length;i++){
        if (this.tasks[i].category === cat) {
          list.push(returnGlobalIndex ? i : this.tasks[i]);
        }
      }
      return list;
    },
    globalIndex: function(task){
      return this.tasks.indexOf(task);
    }
  }
}
</script>

<style lang="scss">
  @use './styles/bootstrap-custom' as *;
</style>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
  text-align: center;
}
table{
  margin: 0px auto;
}
span { cursor: pointer; }

</style>

<style lang="scss">
// Mobile-first responsive styles and nicer category cards
#app { margin-top: 24px; }
#myApplication { max-width: 900px; margin: 0 auto; padding: 0 12px; }

.add-row { display: flex; gap: 8px; align-items: center; justify-content: center; flex-wrap: wrap; margin-bottom: 12px; }
.add-row input { flex: 1 1 200px; max-width: 420px; }
.select-category { flex: 0 0 160px; min-width: 120px; }
.add-row .btn { height: 36px; width: 36px; display:flex; align-items:center; justify-content:center; padding:0; }

/* Larger add button on small screens for easier tapping */
@media (max-width: 699px) {
  .add-row .btn {
    height: 56px;
    width: 56px;
    font-size: 1.25rem;
    border-radius: 10px;
    padding: 0;
  }
}

.categories { display: grid; grid-template-columns: 1fr; gap: 12px; margin-top: 12px; }

.category { background: #ffffff; border: 1px solid #e9ecef; border-radius: 10px; padding: 12px; box-shadow: 0 6px 18px rgba(17,24,39,0.04); }
.category h3 { margin: 0 0 8px 0; font-size: 1rem; text-align: left; }

.category {
  transition: transform 180ms ease, box-shadow 180ms ease;
}
.category:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 28px rgba(17,24,39,0.08);
}

.task { display:flex; align-items:center; justify-content:space-between; gap:8px; padding: 8px; border-radius: 6px; background: #f8f9fa; margin-bottom:8px; transition: background 150ms ease, transform 120ms ease; }
.task:hover { background: #ffffff; transform: translateY(-2px); }
.delete-btn { background: #e74c3c; border: none; color: #fff; padding: 4px 8px; border-radius: 6px; cursor: pointer; }
.delete-btn:hover { filter: brightness(0.95); }

.empty { color: #6c757d; padding: 10px; font-style: italic; text-align: left; }

/* Focus / keyboard accessibility styles */
.add-row input:focus,
.add-row select:focus,
.add-row button:focus,
.delete-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(51,153,255,0.18);
  border-color: #3399ff;
}

/* Use focus-visible when supported to avoid showing focus on mouse click */
@supports selector(:focus-visible) {
  .add-row input:focus:not(:focus-visible),
  .add-row select:focus:not(:focus-visible),
  .add-row button:focus:not(:focus-visible),
  .delete-btn:focus:not(:focus-visible) {
    box-shadow: none;
    border-color: initial;
  }
}

.task { display:flex; align-items:center; justify-content:space-between; gap:8px; padding: 8px; border-radius: 6px; background: #f8f9fa; margin-bottom:8px; }
.task span:first-child { flex: 1 1 auto; text-align: left; }
.task button { flex: 0 0 auto; }

.categories .category:first-child { margin-top: 0; }

@media (min-width: 700px) {
  .categories { grid-template-columns: repeat(2, 1fr); }
}

@media (min-width: 1100px) {
  .categories { grid-template-columns: repeat(3, 1fr); }
}

.title-row { text-align:center; margin-bottom: 6px; }

.strike { text-decoration: line-through; color: #6c757d; }

</style>
